export default "__VITE_ASSET__f53c11a0__"